function detectBasePath(): string {
  const path = window.location.pathname;
  const idx = path.indexOf('/editor');
  return idx >= 0 ? path.slice(0, idx + '/editor'.length) : '/editor';
}

const BASE_PATH = detectBasePath();

export function editorUrl(endpoint: string): string {
  return BASE_PATH + endpoint;
}
